import React from "react";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";
import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import { useDispatch, useSelector } from "react-redux";
import {
  activeConIdSet,
  ActiveFeatures,
  activeFeaturesSet,
  branchNameSet,
  // dealerNameSet,
  getBranchName,
  getDealerName,
  getDealershipName,
  roleSet,
  setNotificationsCount,
} from "../redux/userSlice";
import { Box, IconButton, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import ContactUs from "../sections/dashboard/contact-us";
import { useResponsive } from "../hooks/use-media-query";
import Feedback from "../sections/dashboard/feedback";
import {
  branchUidSet,
  buyAgentSet,
  getIsBuyAgent,
  getOriginUid,
  getRole,
  getUid,
} from "../redux/authSlice";
import { useEffect, useState } from "react";
import InboxIcon from "../assets/icon/inbox";
import ReportIcon from "../assets/icon/report";
import MenuCalendarIcon from "../assets/icon/menu-calendar";
import CarsIcon from "../assets/icon/cars";
import MenuItem from "../components/sidebar-menu/menu-item";
import FacebookMenu from "../components/sidebar-menu/facebook-menu";
import CraigslistMenu from "../components/sidebar-menu/craigslist-menu";
import {
  AdUnits,
  HeadsetMicOutlined,
  Logout,
  // MenuBookOutlined,
  RateReviewOutlined,
  SchoolOutlined,
} from "@mui/icons-material";
import LogOut from "../sections/auth/logout";
import { getMode, modeSet } from "../redux/layoutSlice";
import { limitToLast, onValue, orderByChild, query, ref, update } from "firebase/database";
import { firebaseDb } from "../firebase/app";
import { getData } from "../utils/firebase";
import PersonIcon from "../assets/icon/person";
import Menu from "../components/menu/menu";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Menu as MuiMenu } from "@mui/material";
import { Button } from "../components";
import SoldReview, { Car } from "../components/sold-review/sold-review";
import NotificationIcon from "../assets/icon/notification";
import Notification2Icon from "../assets/icon/notification2";
import TaskIcon from "../assets/icon/task";
import { get12HourFromTimestamp } from "../utils/time-convert";
import CalendarIcon from "../assets/icon/calendar";
import AppointmentCars from "../sections/dashboard/sidebar/appointment-cars";
import CampaignIcon from "../assets/icon/campaign";
import { useQuery } from "@tanstack/react-query";
import LiveSupport from "../pages/support/live-support";

const showNotification = false;

interface AppointmentType {
  id: string;
  appointmentId: string;
  convId: string;
  status: number;
  text: string;
  timestamp: number;
  customerId: string;
  vin: string;
}

interface Branch {
  dealerName: string;
  dealerUid: string;
  product: string;
}

export interface MenuItem {
  title: string;
  link?: string;
  icon: React.ReactNode;
  isNew?: boolean;
  isBeta?: boolean;
  comingSoon?: boolean;
  activeFeatureField?: string;
}

const items: MenuItem[] = [
  { title: "Inbox", link: "/", icon: <InboxIcon sx={{ width: "20px", height: "20px" }} /> },
  {
    title: "Calendar",
    link: "/appointment",
    icon: <MenuCalendarIcon fill="#fff" sx={{ width: "20px", height: "20px" }} />,
  },
  {
    title: "Cartelligent",
    link: "/cars",
    icon: <CarsIcon fill="#fff" sx={{ width: "20px", height: "20px" }} />,
  },
  {
    title: "Task",
    link: "/task",
    icon: <TaskIcon sx={{ width: "20px", height: "20px" }} />,
  },
  {
    title: "Campaign",
    link: "/campaign",
    icon: <CampaignIcon fill="#fff" sx={{ width: "20px", height: "20px" }} />,
    isNew: true,
  },
  {
    title: "Review Max",
    link: "/review-max",
    icon: <RateReviewOutlined sx={{ width: "20px", height: "20px" }} />,
    isNew: true,
  },
  {
    title: "Auto Marketing",
    link: "/auto-marketing",
    icon: <AdUnits sx={{ width: "20px", height: "20px" }} />,
    isNew: true,
    activeFeatureField: "autoMarketing",
  },

  { title: "Report", link: "/report", icon: <ReportIcon sx={{ width: "20px", height: "20px" }} /> },
  {
    title: "Training",
    link: "/help-center",
    // icon: <Help sx={{ width: "20px", height: "20px" }} />,
    icon: <SchoolOutlined sx={{ width: "20px", height: "20px" }} />,
  },
  // {
  //   title: "Knowledge Base",
  //   link: "/knowledge-base",
  //   icon: <MenuBookOutlined sx={{ width: "20px", height: "20px" }} />,
  // },
  {
    title: "Support",
    link: "/support",
    // icon: <Help sx={{ width: "20px", height: "20px" }} />,
    icon: <HeadsetMicOutlined sx={{ width: "20px", height: "20px" }} />,
  },
  {
    title: "Settings",
    link: "/setting",
    icon: <SettingsRoundedIcon sx={{ width: "20px", height: "20px" }} />,
  },
];

const buyAgentItems: MenuItem[] = [
  { title: "inbox", link: "/", icon: <InboxIcon sx={{ width: "20px", height: "20px" }} /> },
  {
    title: "Calendar",
    link: "/appointment",
    icon: <MenuCalendarIcon fill="#fff" sx={{ width: "20px", height: "20px" }} />,
  },
  {
    title: "Setting",
    link: "/setting",
    icon: <SettingsRoundedIcon sx={{ width: "20px", height: "20px" }} />,
  },
];

const LeftSidebar = ({ openSidebar, setOpen }: any) => {
  const [menuItems, setMenuItems] = useState<MenuItem[]>(items);

  const dispatch = useDispatch();

  // const navigate = useNavigate();
  const [openFeedBackDialog, setOpenFeedBackDialog] = useState(false);
  const [openLogout, setOpenLogout] = useState(false);
  const [openSoldReview, setOpenSoldReview] = useState<boolean>(false);

  const { isSmall } = useResponsive();
  const isBuyAgent = useSelector(getIsBuyAgent);
  const [notificationAnchorEl, setNotificationAnchorEl] = React.useState<null | HTMLElement>(null);
  const [branchAnchorEl, setBranchAnchorEl] = React.useState<null | HTMLElement>(null);
  const [branches, setBranches] = React.useState<Branch[]>([]);

  const [cars, setCars] = useState<Car[]>([]);
  const [appointments, setAppointments] = useState<AppointmentType[]>([]);

  const [purchaseModalOpen, setPurchaseModalOpen] = useState<boolean>(false);
  const [selectedAppointment, setSelectedAppointment] = useState<AppointmentType | null>(null);
  const [notShowUp, setNotShowUp] = useState<boolean>(false);

  const [contactOpen, setOpenContact] = useState(false);
  const mode = useSelector(getMode);
  const uid = useSelector(getUid);
  const role = useSelector(getRole);
  const originUid = useSelector(getOriginUid);

  const branchUidStorage = localStorage.getItem("branchUid");
  const branchName = useSelector(getBranchName);
  const dealerName = useSelector(getDealerName);
  const dealershipName = useSelector(getDealershipName);

  const navigate = useNavigate();

  const handleOpenBranchMenu = (event: React.MouseEvent<HTMLElement>) => {
    if (branches.length < 2) {
      return;
    }
    setBranchAnchorEl(event.currentTarget);
  };

  const handleOpenNotificationMenu = (event: React.MouseEvent<HTMLElement>) => {
    setNotificationAnchorEl(event.currentTarget);
  };

  const changeTheme = () => {
    dispatch(modeSet(mode === "dark" ? "light" : "dark"));
    localStorage.setItem("colorMode", mode === "dark" ? "light" : "dark");

    const data = {
      theme: mode === "dark" ? "light" : "dark",
    };
    const userPreferences = {
      darkMode: mode === "dark" ? false : true,
    };
    localStorage.setItem("userPreferences", JSON.stringify(userPreferences));
    update(ref(firebaseDb, `dealers/${uid}/info/dashboardSettings`), data);

    // for pwa
    const newTheme = mode === "dark" ? "light" : "dark";
    const themeColor = newTheme === "dark" ? "#000000" : "#ffffff";
    const metaThemeColor = document.querySelector("meta[name=theme-color]");
    if (metaThemeColor) {
      metaThemeColor.setAttribute("content", themeColor);
    } else {
      const meta = document.createElement("meta");
      meta.name = "theme-color";
      meta.content = themeColor;
      document.head.appendChild(meta);
    }
  };

  // get active features
  const { data: activeFeatures = [] as ActiveFeatures[] } = useQuery({
    queryKey: ["activeFeatures", uid],
    queryFn: async () => {
      const response = await getData(`dealers/${uid}/info/activeFeatures`);
      return Object.entries(response || {})
        .filter(([, value]) => value === true)
        .map(([key]) => key);
    },
    enabled: !!uid,
  });

  useEffect(() => {
    if (activeFeatures && Array.isArray(activeFeatures)) {
      dispatch(activeFeaturesSet(activeFeatures as ActiveFeatures[]));
    }
  }, [activeFeatures, dispatch]);

  const handleFeedback = () => {
    setOpenFeedBackDialog(!openFeedBackDialog);
  };

  // const handleNotShowUp = useCallback(
  //   (appointmentId: string) => {
  //     const data = {
  //       uid,
  //       appointmentId,
  //       convId: appointments.find((appointment) => appointment.appointmentId === appointmentId)
  //         ?.convId,
  //       reviewType: "notShowUp",
  //       reviewStatus: false,
  //     };
  //     post(data, "salesagent-MaxReview")
  //       .then((res) => {
  //         console.log(res);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   },
  //   [appointments, uid]
  // );

  const getBranches = React.useCallback(() => {
    getData(`Users/${originUid}`)
      .then((data: any) => {
        if (!data) {
          return;
        }
        //TODO: set branches and role

        // dealerNameSet(data?.displayName);

        const branchesData = data.branches
          ? Object.entries(data.branches).map(([key, item]: any) => ({
              dealerName: item,
              dealerUid: key,
              product: "sales agent",
            }))
          : [];
        const buyBranchesData = data.buyBranches
          ? Object.entries(data.buyBranches).map(([key, item]: any) => ({
              dealerName: item,
              dealerUid: key,
              product: "buy agent",
            }))
          : [];
        if (data.role !== "staff") {
          setBranches([...branchesData, ...buyBranchesData]);
        }

        if (!branchUidStorage) {
          const newBranchUid =
            branchesData.length > 0 ? branchesData[0].dealerUid : buyBranchesData[0].dealerUid;
          const newBranchName =
            branchesData.length > 0 ? branchesData[0].dealerName : buyBranchesData[0].dealerName;
          if (data.role !== "staff") {
            dispatch(branchUidSet(newBranchUid));
            dispatch(branchNameSet(newBranchName));
          }

          const buyagentStatus = branchesData ? false : true;
          dispatch(buyAgentSet(buyagentStatus));
          localStorage.setItem("branchUid", newBranchUid);
          localStorage.setItem("branchName", newBranchName);
          localStorage.setItem("product", buyagentStatus ? "sales agent" : "buy agent");
        } else {
          dispatch(branchUidSet(branchUidStorage));
        }
        dispatch(roleSet(data.role));
      })
      .catch((err) => console.log(err));
  }, [branchUidStorage, dispatch, originUid, setBranches]);

  // const getDealerName = useEffect(() => {
  //   const path = `Users/${staffUid}`
  // },[])

  // useEffect(() => {
  //   const databaseRef = query(
  //     ref(firebaseDb, `cars/${uid}`),
  //     orderByChild("soldReview"),
  //     equalTo(false),
  //     limitToLast(10)
  //   );

  //   const unsubscribe = onValue(databaseRef, async (snapshot) => {
  //     if (snapshot.exists()) {
  //       const list = Object.entries(snapshot.val() || {}).map(([key, value]: [string, any]) => ({
  //         vin: key,
  //         ...(value as object),
  //       }));
  //       setCars(list as Car[]);
  //     }
  //   });

  //   return () => {
  //     unsubscribe(); // Call unsubscribe to detach the listener
  //   };
  // }, [uid]);

  useEffect(() => {
    const databaseRef = query(
      ref(firebaseDb, `notifications/${uid}/appointmentShowUp`),
      orderByChild("timestamp"),
      limitToLast(10)
    );

    const unsubscribe = onValue(databaseRef, async (snapshot) => {
      if (snapshot.exists()) {
        const appointmentsList = Object.entries(snapshot.val() || {}).map(
          ([key, value]: [string, any]) => ({
            id: key,
            ...(value as object),
          })
        );
        setAppointments(appointmentsList as AppointmentType[]);
      } else {
        setAppointments([]);
      }
    });

    return () => {
      unsubscribe(); // Call unsubscribe to detach the listener
      console.log("unsubscribe");
    };
  }, [uid]);

  useEffect(() => {
    const databaseRef = query(
      ref(firebaseDb, `notifications/${uid}/carReview`),
      // orderByChild("timestamp"),
      limitToLast(10)
    );

    const unsubscribe = onValue(databaseRef, async (snapshot) => {
      if (snapshot.exists()) {
        const carsList = Object.entries(snapshot.val() || {}).map(
          ([key, value]: [string, any]) => ({
            vin: key,
            ...(value as object),
          })
        );
        setCars(carsList as Car[]);
      } else {
        setCars([]);
      }
    });

    return () => {
      unsubscribe(); // Call unsubscribe to detach the listener
      console.log("unsubscribe");
    };
  }, [uid]);

  useEffect(() => {
    if (cars && appointments) {
      dispatch(setNotificationsCount(cars.length + appointments.length));
    } else {
      dispatch(setNotificationsCount(0));
    }
  }, [appointments, cars, dispatch]);

  useEffect(() => {
    if (isBuyAgent) {
      setMenuItems(buyAgentItems);
    } else {
      setMenuItems(items);
    }
  }, [isBuyAgent]);

  useEffect(() => {
    getBranches();
  }, [getBranches]);

  // React.useEffect(() => {
  //   const handleGetItem = () => {
  //     const path = `/dealers/${uid}/info/dealerName`;
  //     getData(path)
  //       .then((r) => {
  //         dispatch(dealerNameSet(r));
  //       })
  //       .catch((r) => console.log(`error getting ${path}`, r));
  //   };

  //   handleGetItem();
  // }, [dispatch, uid]);

  // useEffect(() => {
  //   if (isBuyAgent) {
  //     setFilterItems(buyAgentFilters);
  //   } else {
  //     setFilterItems(filters);
  //   }
  // }, [isBuyAgent]);

  return (
    <React.Fragment>
      <Box
        sx={{
          padding: "12px",
          // minHeight: "122px",
          boxSizing: "border-box",
          borderBottom: "1px solid #364153",
          display: "flex",
          flexDirection: "column",
          gap: "6px",
        }}
      >
        {/* {!openSidebar && <img src={"/images/white-drivee.webp"} alt="drivee" width={"40px"} />} */}

        <Box sx={{ height: "50px" }}>
          <img
            src={"/images/white-drivee.webp"}
            alt="drivee"
            width={openSidebar ? "64px" : "40px"}
            style={{ transition: "width 0.3s ease-in-out" }}
          />

          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: "400",
              color: "#99A1AF",
              whiteSpace: "normal",
              width: openSidebar ? "auto" : "0px",
              height: "21px",
              overflow: "hidden",
              opacity: openSidebar ? 1 : 0,
              transition: "opacity 0.3s ease-in-out",
            }}
          >
            Most Advanced AI CRM for Dealers
          </Typography>
        </Box>

        {branches?.length < 2 && dealerName !== dealershipName && (
          <Box
            sx={{
              borderLeft: "2px solid #dae1ed",
              paddingLeft: "8px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: "13px",
                color: "#dae1ed",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                lineHeight: "normal",
                fontWeight: "700",
              }}
            >
              {dealershipName}
            </Typography>
          </Box>
        )}

        <Box
          sx={{
            display: "flex",
            flexDirection: openSidebar ? "row" : "column",
            gap: "8px",
            alignItems: "center",
          }}
        >
          <MenuItem
            item={{
              icon: <PersonIcon sx={{ width: "18px" }} />,
              title:
                branches?.length > 1 && branchName && role !== "staff" ? branchName : dealerName,
              // title: dealerName,
            }}
            textWidth={
              activeFeatures.includes("reviewMax")
                ? branches.length > 1
                  ? "116px"
                  : "136px"
                : "168px"
            }
            openSidebar={openSidebar}
            onClick={handleOpenBranchMenu}
            endIcon={
              branches.length > 1 ? (
                <ExpandMoreIcon
                  sx={{
                    fontSize: "20px",
                    color: "white",
                    transform: branchAnchorEl ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.2s ease-in-out",
                  }}
                />
              ) : (
                ""
              )
            }
            sx={{ border: "1px solid #4D5B82 !important", borderRadius: "8px" }}
          />
          <Menu
            anchorEl={branchAnchorEl}
            handleClose={() => {
              setBranchAnchorEl(null);
            }}
            sx={{
              top: "100px !important",
              "& .MuiPaper-root": {
                maxWidth: "220px !important",
                width: "220px !important",
                minWidth: "208px !important",
                backgroundColor: "#121C3C",
                top: openSidebar ? "64px !important" : "-58px !important",
                border: "1px solid #333D5A",
                color: "white",
                borderRadius: "8px",
                overflow: "hidden",
                padding: "8px 0",
                left: openSidebar ? "16px !important" : "75px !important",
              },
            }}
            anchorOrigin={{ vertical: "top", horizontal: "left" }}
            items={branches.map((branch) => ({
              label: (
                <Box
                  key={branch.dealerUid}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    gap: "16px",
                    width: "100%",
                    alignItems: "center",
                    backgroundColor: branch.dealerUid === uid ? "#212E59" : "",
                    borderRadius: "8px",
                    padding: "8px",
                  }}
                >
                  <Typography
                    fontWeight={500}
                    sx={{
                      fontSize: "16px",
                      color: "white",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {branch.dealerName}
                  </Typography>
                  {branches.find((item) => item.product === "buy agent") &&
                    branches.find((item) => item.product === "sales agent") && (
                      <Box
                        sx={{
                          fontSize: "11px",
                          borderRadius: "50px",
                          padding: "0 6px",
                          backgroundColor: branch.product === "sales agent" ? "#2B7FFF" : "#279f23",
                          color: "white",
                          fontWeight: "300",
                          textTransform: "capitalize",
                        }}
                      >
                        {branch?.product}
                      </Box>
                    )}
                </Box>
              ),
              onClick: () => {
                navigate("/");
                dispatch(branchUidSet(branch.dealerUid));
                dispatch(branchNameSet(branch.dealerName));
                localStorage.setItem("branchUid", branch.dealerUid);
                localStorage.setItem("branchName", branch.dealerName);
                dispatch(activeConIdSet(null));
                setBranchAnchorEl(null);
                const buyagentStatus = branch.product === "sales agent" ? false : true;
                dispatch(buyAgentSet(buyagentStatus));
              },
              sxText: { color: branch.dealerUid === uid ? "#0290ff !important" : "" },
            }))}
          />
          {activeFeatures.includes("reviewMax") && (
            <Box sx={{ height: "100%" }}>
              <IconButton
                onClick={handleOpenNotificationMenu}
                sx={{
                  width: "44px",
                  height: "100%",
                  backgroundColor: "#9747FF9C",
                  borderRadius: "8px",
                  "&:hover": { backgroundColor: "#9747FF9C" },
                  position: "relative",
                }}
              >
                <NotificationIcon
                  sx={{
                    width: "20px",
                    animation:
                      cars?.length + appointments?.length > 0
                        ? "ring 4s 10s ease-in-out infinite"
                        : "none",
                    transformOrigin: "50% 4px",
                    rotate: "-30deg",
                    marginRight: "10px",
                    "@keyframes ring": {
                      "0%": { transform: "rotateZ(0)" },
                      "1%": { transform: "rotateZ(22deg)" },
                      "3%": { transform: "rotateZ(-20deg)" },
                      "5%": { transform: "rotateZ(24deg)" },
                      "7%": { transform: "rotateZ(-22deg)" },
                      "9%": { transform: "rotateZ(22deg)" },
                      "11%": { transform: "rotateZ(-20deg)" },
                      "13%": { transform: "rotateZ(18deg)" },
                      "15%": { transform: "rotateZ(-16deg)" },
                      "17%": { transform: "rotateZ(14deg)" },
                      "19%": { transform: "rotateZ(-12deg)" },
                      "21%": { transform: "rotateZ(10deg)" },
                      "23%": { transform: "rotateZ(-8deg)" },
                      "25%": { transform: "rotateZ(6deg)" },
                      "27%": { transform: "rotateZ(-4deg)" },
                      "29%": { transform: "rotateZ(2deg)" },
                      "31%": { transform: "rotateZ(-1deg)" },
                      "33%": { transform: "rotateZ(1deg)" },
                      "35%": { transform: "rotateZ(0)" },
                      "37%": { transform: "rotateZ(0)" },
                      "39%": { transform: "rotateZ(0)" },
                      "41%": { transform: "rotateZ(0)" },
                      "43%": { transform: "rotateZ(0)" },
                      "45%": { transform: "rotateZ(0)" },
                      "47%": { transform: "rotateZ(0)" },
                      "49%": { transform: "rotateZ(0)" },
                      "100%": { transform: "rotateZ(0)" },
                    },
                  }}
                />
                {(cars?.length || appointments?.length) > 0 && (
                  <Box
                    sx={{
                      width: "18px",
                      height: "18px",
                      borderRadius: "50%",
                      backgroundColor: "red",
                      position: "absolute",
                      top: "-6px",
                      right: "-6px",
                      color: "white",
                      fontSize: "10px",
                      fontWeight: "400",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {cars?.length + appointments?.length > 9
                      ? "9+"
                      : cars?.length + appointments?.length}
                  </Box>
                )}
              </IconButton>
              <MuiMenu
                anchorEl={notificationAnchorEl}
                anchorOrigin={{ vertical: "top", horizontal: "left" }}
                id="menu-appbar"
                keepMounted
                onClose={() => setNotificationAnchorEl(null)}
                open={Boolean(notificationAnchorEl)}
                sx={{
                  zIndex: (theme) => theme.zIndex.modal + 1,
                  "& .MuiPaper-root": {
                    borderRadius: "8px",
                    padding: "16px !important",
                    borderTopLeftRadius: isSmall ? "8px" : "0px !important",
                    borderTopRightRadius: isSmall ? "0px !important" : "8px",
                    top: isSmall
                      ? "160px !important"
                      : openSidebar
                      ? "104px !important"
                      : "100px !important",
                    left: isSmall
                      ? "-219px !important"
                      : openSidebar
                      ? "32px !important"
                      : "2px !important",
                    maxWidth: isSmall ? "275px !important" : "400px !important",
                  },
                  "& .MuiMenu-list": {
                    padding: "0 !important",
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  },
                  // border: "1px solid #333D5A",
                  // color: "white",
                  // borderRadius: "8px",
                  // overflow: "hidden",
                  // padding: "8px 0",
                  left: openSidebar ? "232px !important" : "75px !important",
                }}
                transformOrigin={{
                  horizontal: "right",
                  vertical: "top",
                }}
              >
                <Box sx={{ maxHeight: "70dvh" }}>
                  {cars?.length > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "8px",
                        padding: "16px",
                        borderRadius: "8px",
                        border: "1px solid #E2E8F0",
                        backgroundColor: "#F8FCFF",
                      }}
                    >
                      <Box
                        sx={{
                          backgroundColor: "rgba(41, 126, 255, 0.10)",
                          borderRadius: "50%",
                          padding: "8px",
                          height: "32px",
                          width: "32px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                          position: "relative",
                        }}
                      >
                        <Notification2Icon sx={{ width: "16px", height: "16px" }} />
                        <Box
                          sx={{
                            width: "18px",
                            height: "18px",
                            borderRadius: "50%",
                            backgroundColor: "red",
                            position: "absolute",
                            top: "-6px",
                            right: "-6px",
                            color: "white",
                            fontSize: "10px",
                            fontWeight: "400",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {cars?.length > 9 ? "9+" : cars?.length}
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        <Box>
                          <Box>
                            <Typography sx={{ fontSize: "14px", fontWeight: "600" }}>
                              Review and mark sold vehicles
                            </Typography>
                          </Box>
                          <Typography
                            sx={{ fontSize: "14px", fontWeight: "400", color: "#64748B" }}
                          >
                            Review your inventory and update vehicle status
                          </Typography>
                        </Box>
                        <Button
                          onClick={() => {
                            setNotificationAnchorEl(null);
                            // setOpenSoldReview(true);
                            navigate("/review-max");
                          }}
                          variant="outlined"
                          sx={{
                            width: "fit-content",
                            color: "#297EFF",
                            border: "1px solid #297EFF",
                            "&:hover": {
                              border: "1px solid #297EFF",
                            },
                          }}
                        >
                          Review Inventory
                        </Button>
                      </Box>
                    </Box>
                  )}
                  {showNotification && appointments?.length > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        marginTop: "8px",
                        paddingBottom: "16px",
                      }}
                    >
                      {appointments.map((appointment) => (
                        <Box
                          key={appointment.id}
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "8px",
                            padding: "16px",
                            borderRadius: "8px",
                            border: "1px solid #E5E7EB",
                            backgroundColor: "#eafbf3",
                            maxWidth: "400px",
                          }}
                        >
                          <Box
                            sx={{
                              backgroundColor: "rgba(41, 126, 255, 0.10)",
                              borderRadius: "50%",
                              padding: "8px",
                              height: "32px",
                              width: "32px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <CalendarIcon
                              iconColor="#297EFF"
                              sx={{ width: "16px", height: "16px" }}
                            />
                          </Box>
                          <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                            <Box>
                              <Box>
                                <Typography sx={{ fontSize: "14px", fontWeight: "600" }}>
                                  Did your {get12HourFromTimestamp(appointment.timestamp)}{" "}
                                  appointment show up?
                                </Typography>
                              </Box>
                              <Typography
                                sx={{ fontSize: "14px", fontWeight: "400", color: "#64748B" }}
                              >
                                {appointment?.text}
                              </Typography>
                            </Box>
                            <Box sx={{ display: "flex", flexDirection: "row", gap: "8px" }}>
                              <Button
                                onClick={() => {
                                  setSelectedAppointment(appointment);
                                  setNotificationAnchorEl(null);
                                  setPurchaseModalOpen(true);
                                }}
                                variant="outlined"
                                sx={{
                                  width: "fit-content",
                                  color: "#297EFF",
                                  border: "1px solid #297EFF",
                                  "&:hover": {
                                    border: "1px solid #297EFF",
                                  },
                                }}
                              >
                                Yes
                              </Button>
                              <Button
                                // onClick={() => handleNotShowUp(appointment.appointmentId)}
                                onClick={() => {
                                  setSelectedAppointment(appointment);
                                  setNotificationAnchorEl(null);
                                  setPurchaseModalOpen(true);
                                  setNotShowUp(true);
                                }}
                                variant="outlined"
                                sx={{
                                  width: "fit-content",
                                  color: "#297EFF",
                                  border: "1px solid #297EFF",
                                  "&:hover": {
                                    border: "1px solid #297EFF",
                                  },
                                }}
                              >
                                No
                              </Button>
                            </Box>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  )}
                  {cars?.length === 0 && appointments?.length === 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "8px",
                        padding: "16px",
                        borderRadius: "8px",
                        border: "1px solid #E2E8F0",
                        backgroundColor: "#F9FAFB",
                        fontSize: "14px",
                        fontWeight: "400",
                        minWidth: "300px",
                        height: "80px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      No notifications right now — you’re all set!
                    </Box>
                  )}
                </Box>
              </MuiMenu>
            </Box>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          padding: "8px",
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        {menuItems
          // .filter(
          //   (item) =>
          //     item?.activeFeatureField !== "autoMarketing" &&
          //     activeFeatures.includes("FBMPDesktopApp")
          // )
          .map((item, index) =>
            item.activeFeatureField === "autoMarketing" &&
            activeFeatures.includes("FBMPDesktopApp") ? null : (
              <React.Fragment key={index}>
                <MenuItem
                  item={item}
                  openSidebar={openSidebar}
                  handleCloseSidebar={() => setOpen(false)}
                />
                {!isBuyAgent &&
                  activeFeatures.includes("FBMPDesktopApp") &&
                  item.link === "/review-max" && (
                    <FacebookMenu
                      openSidebar={openSidebar}
                      handleCloseSidebar={() => setOpen?.(false)}
                    />
                  )}
                {!isBuyAgent &&
                  activeFeatures.includes("craigslistAds") &&
                  item.link === "/review-max" && (
                    <CraigslistMenu
                      openSidebar={openSidebar}
                      handleCloseSidebar={() => setOpen?.(false)}
                    />
                  )}
              </React.Fragment>
            )
          )}
      </Box>

      <Box
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"flex-end"}
        height={"100%"}
      >
        {/* {isCustomLayout && (
          <>
            <Divider />
            <CustomListItemButton onClick={() => navigate("/cars")}>
              <CustomListItemIcon>
                <DirectionsCarRoundedIcon color="primary" />
                <Typography variant="caption">Cars</Typography>
              </CustomListItemIcon>
            </CustomListItemButton>
            <CustomListItemButton onClick={() => navigate("/setting")}>
              <CustomListItemIcon>
                <SettingsRoundedIcon color="primary" />
                <Typography variant="caption">Setting</Typography>
              </CustomListItemIcon>
            </CustomListItemButton>
            <CustomListItemButton onClick={handleFeedback}>
              <CustomListItemIcon>
                <FeedbackIcon color="primary" />
                <Typography variant="caption">Feedback</Typography>
              </CustomListItemIcon>
            </CustomListItemButton>
            <Divider />
          </>
        )} */}

        <Box sx={{ width: "100%", padding: "8px", borderTop: "1px solid #364153" }}>
          <MenuItem
            item={{
              icon:
                mode === "dark" ? (
                  <LightModeRoundedIcon sx={{ fontSize: "20px" }} />
                ) : (
                  <DarkModeRoundedIcon sx={{ fontSize: "20px" }} />
                ),
              title: mode === "dark" ? "Light" : "Dark",
            }}
            openSidebar={openSidebar}
            onClick={changeTheme}
          ></MenuItem>
          <MenuItem
            item={{ icon: <Logout />, title: "log out" }}
            openSidebar={openSidebar}
            onClick={() => setOpenLogout(true)}
          ></MenuItem>
        </Box>

        {/* <CustomListItemButton onClick={() => navigate("/setting/dealership")}>
          <CustomListItemIcon>
            <SettingsRoundedIcon color="primary" />
            <Typography variant="caption" sx={{ color: "#a0a0a0", fontSize: "10px" }}>
              Setting
            </Typography>
          </CustomListItemIcon>
        </CustomListItemButton>

        <CustomListItemButton onClick={() => navigate("/training-request")}>
          <CustomListItemIcon>
            <ModelTrainingRoundedIcon color="primary" />
            <Typography variant="caption" sx={{ color: "#a0a0a0", fontSize: "10px" }}>
              Training
            </Typography>
          </CustomListItemIcon>
        </CustomListItemButton>
        <CustomListItemButton onClick={handleFeedback}>
          <CustomListItemIcon>
            <FeedbackIcon color="primary" />
            <Typography variant="caption" sx={{ color: "#a0a0a0", fontSize: "10px" }}>
              Feedback
            </Typography>
          </CustomListItemIcon>
        </CustomListItemButton>
        <CustomListItemButton onClick={handleContact}>
          <CustomListItemIcon>
            <ContactMailIcon color="primary" />
            <Typography variant="caption" sx={{ color: "#a0a0a0", fontSize: "10px" }}>
              Contact Us
            </Typography>
          </CustomListItemIcon>
        </CustomListItemButton> */}
      </Box>

      {contactOpen && <ContactUs open={contactOpen} handleClose={() => setOpenContact(false)} />}
      <Feedback open={openFeedBackDialog} handleClose={handleFeedback} />
      <LogOut open={openLogout} handleClose={() => setOpenLogout(false)} />
      {openSoldReview && selectedAppointment && (
        <SoldReview cars={cars} open={openSoldReview} setOpen={setOpenSoldReview} />
      )}
      {purchaseModalOpen && selectedAppointment && (
        <AppointmentCars
          notShowUp={notShowUp}
          vin={selectedAppointment.vin}
          customerId={selectedAppointment.convId}
          appointmentId={selectedAppointment.appointmentId}
          open={purchaseModalOpen}
          setOpen={(value: boolean) => {
            setPurchaseModalOpen(value);
            setNotShowUp(false);
          }}
          notificationId={selectedAppointment.id}
        />
      )}
      {activeFeatures.includes("supportInAllPages") && <LiveSupport />}
    </React.Fragment>
  );
};

export default LeftSidebar;
